import React from "react"
import SSO from "@views/features/single-sign-on"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - Single Sign-On"
      keywords={[
        `engineid`,
        `security`,
        `login fatigue`,
        `password fatigue`,
        `single sign on`,
        `consolidate apps`,
        `saml`,
        `openid`,
        `federated login`,
        `authentication`,
        `authorization`,
        `api`,
        `cloud`,
        `development`,
        `sdk`,
        `identity management`,
        `access management`,
      ]}
    />
    <SSO />
  </div>
)

export default IndexPage
